import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App.js';
import { initThemeFromStorage } from './lib/theme.js';
import './index.css';
import './i18n.js';

initThemeFromStorage();

// Firebase action links occasionally arrive with a double slash after the host
// (http://localhost:5173//__/auth/action). Normalize before React Router boots.
{
  const { pathname, search, hash } = window.location;
  const normalized = pathname.replace(/^\/+/, '/');
  if (normalized !== pathname) {
    window.history.replaceState(null, '', `${normalized}${search}${hash}`);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
